/** Mirrors datahub's `BookingTypes` (`datahub/tasks/models.ts`) verbatim — same wire values. */
export var BookingTypes;
(function (BookingTypes) {
    BookingTypes["BookingPrimaryConfirmed"] = "PRIMARYCONFIRMED";
    BookingTypes["BookingSecondaryConfirmed"] = "SECONDARYCONFIRMED";
    BookingTypes["Booking3rdParty"] = "3RDPARTY";
    BookingTypes["Booking3rdPartyPrimaryConfirmed"] = "3RDPARTYPRIMARYCONFIRMED";
    BookingTypes["Booking3rdPartySecondaryConfirmed"] = "3RDPARTYSECONDARYCONFIRMED";
    BookingTypes["BookingEsoft"] = "ESOFT";
})(BookingTypes || (BookingTypes = {}));
